<template>
    <div>
        <el-carousel :interval="3000" arrow="always"  height="430px" >
            <el-carousel-item v-for="(item,adIndex) in list_img" :key="adIndex">
                <img :src="item.url" alt="">
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
    export default {
        props: ['bannerRotion'],
        data(){
            return{
               list_img:[
                 {url:require('../assets/banner/1.jpg')},
                 {url:require('../assets/banner/2.jpg')},
                 {url:require('../assets/banner/3.jpg')},
               ],
            }
        },
        created(){
        },
        mounted(){},
        methods:{
           
        },
    }
</script>

<style lang="scss" scoped>
  .el-carousel__item {
    width: 100%;
  }
  
</style>